import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Motion";

export const FinalCTA = () => (
  <section className="grain relative overflow-hidden py-28 lg:py-40" data-testid="final-cta-section">
    <div aria-hidden className="pointer-events-none absolute left-1/4 top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-flash/25 blur-[160px]" />
    <div aria-hidden className="pointer-events-none absolute right-0 top-0 h-[420px] w-[420px] rounded-full bg-violet/35 blur-[160px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <h2 className="font-display text-5xl font-extrabold leading-[0.9] tracking-[-0.03em] sm:text-7xl lg:text-[8rem]">
        <MaskLines animateOnMount={false} lines={["Estava lá?", <span key="b" className="text-outline-flash">Suas fotos também.</span>]} />
      </h2>
      <Reveal className="mt-12 flex flex-wrap gap-3" delay={0.2}>
        <Link to="/eventos" data-testid="cta-find-photos-btn" className="group inline-flex items-center gap-2 rounded-full bg-flash px-8 py-4 font-semibold text-ink transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-flash-2">
          Encontrar minhas fotos <ArrowUpRight className="h-5 w-5 transition-transform group-hover:rotate-45" />
        </Link>
        <Link to="/fotografos" data-testid="cta-hire-btn" className="inline-flex items-center gap-2 rounded-full border border-white/25 px-8 py-4 font-semibold transition-colors hover:border-violet-lilac">
          Contratar um fotógrafo
        </Link>
      </Reveal>
    </div>
  </section>
);
